module.exports = __webpack_public_path__ + "static/media/002-cloudy-13.2776a530.svg";